// Adsterra publisher units (public, page-embedded IDs — not secrets).
export const AD_HOST = "https://bancadeltempoidea.org";

export const ADSTERRA = {
  desktop: { key: "cf5583314a177c7bb527cd8e5611d481", width: 728, height: 90 },
  mobile: { key: "4b719f3814576f34050541654320d560", width: 320, height: 50 },
  native: { key: "aab888cd3216af199864f7e0657439ca" },
};

export const AD_DEFAULTS = { banner_every_rows: 4, native_every_cards: 8, player_banner: true };

// Isolated iframe document per unit: Adsterra's global `atOptions` can't collide between
// banners, and the network scripts never block the app's own rendering.
const shell = (body) =>
  `<!doctype html><html><head><meta name="viewport" content="width=device-width,initial-scale=1">` +
  `<style>html,body{margin:0;padding:0;background:transparent;overflow:hidden;color:#bbb;font-family:sans-serif}</style>` +
  `</head><body>${body}</body></html>`;

export const bannerDoc = ({ key, width, height }) =>
  shell(
    `<script>atOptions={'key':'${key}','format':'iframe','height':${height},'width':${width},'params':{}};</script>` +
      `<script src="${AD_HOST}/22/${key}"></script>`,
  );

export const nativeDoc = ({ key }) =>
  shell(`<script async="async" data-cfasync="false" src="${AD_HOST}/21/${key}"></script><div id="container-${key}"></div>`);
